const {
  NODE_ENV,
  CLIENT_DEV_URL,
  CLIENT_STAGING_URL,
  CLIENT_PROD_URL,
  SERVER_DEV_URL,
  SERVER_STAGING_URL,
  SERVER_PROD_URL,
  TICKET_SERVER_DEV_URL,
  TICKET_SERVER_STAGING_URL,
  TICKET_SERVER_PROD_URL,
} = require("../../config");

function getClientURL() {
  const env = NODE_ENV || "development";
  let url = CLIENT_DEV_URL;
  switch (env.trim()) {
    case "development":
      url = CLIENT_DEV_URL;
      break;
    case "staging":
      url = CLIENT_STAGING_URL;
      break;
    case "production":
      url = CLIENT_PROD_URL;
      break;
    default:
      url = CLIENT_DEV_URL;
  }
  return url;
}

function getServerURL(endpointUrl) {
  const env = (NODE_ENV || "development").trim();

  const urls = {
    development: {
      default: SERVER_DEV_URL,
      ecommerce: TICKET_SERVER_DEV_URL,
    },
    staging: {
      default: SERVER_STAGING_URL,
      ecommerce: TICKET_SERVER_STAGING_URL,
    },
    production: {
      default: SERVER_PROD_URL,
      ecommerce: TICKET_SERVER_PROD_URL,
    },
  };

  const config = urls[env] || urls.development;

  // Decide which URL to use based on endpointUrl
  if (endpointUrl && endpointUrl.startsWith("/api/ecommerce")) {
    return config.ecommerce;
  }

  return config.default;
}

module.exports = {
  getClientURL,
  getServerURL,
};
